export const ADD_TEEN_EVENTS = {
  VIEW_CREATE_TEEN_DATA_FORM: 'view_create_teen_data_form',
  SELECT_NEXT_CREATE_TEEN_DATA_FORM: 'select_next_create_teen_data_form',
  SELECT_BACK_CREATE_TEEN_DATA_FORM: 'select_back_create_teen_data_form',
  SELECT_CREATE_TEEN_DATA_FORM: 'select_create_teen_data_form',
  SELECT_CREATE_TEEN_FORM_WITH_SSN: 'select_create_teen_form_with_ssn',
  SELECT_CREATE_TEEN_FORM_WITHOUT_SSN: 'select_create_teen_form_without_ssn',
  API_SUCCESS_CREATE_TEEN: 'api_success_create_teen',
  API_SUCCESS_CREATE_WALLET_AND_VIRTUAL_CARD:
    'api_success_create_wallet_and_virtual_card',
  API_ERROR_CREATE_TEEN: 'api_error_create_teen',
  VIEW_CREATE_TEEN_WITH_TEEN_DATA: 'view_create_teen_with_teen_data',
  API_ERROR_REQUEST_CARD: 'api_error_request_card',
  VIEW_ERROR_USER_NOT_UUID: 'view_error_user_not_uuid',
  API_SUCCESS_CREATE_VIRTUAL_CARD: 'api_success_create_virtual_card',
  SELECT_ADD_TEEN_FORM_LET_US_KNOW: 'select_add_teen_form_let_us_know',
  SELECT_BACK_TO_EDIT_TEEN_INFO_BUTTON_FROM_ADD_TEEN_LET_US_KNOW_SCREEN:
    'select_back_to_edit_teen_info_button_from_add_teen_let_us_know_screen',
  SELECT_GO_TO_HOME_BUTTON_FROM_ADD_TEEN_LET_US_KNOW_SCREEN:
    'select_go_to_home_button_from_add_teen_let_us_know_screen',
  VIEW_ADD_TEEN_WITHOUT_SSN_WARNING_SCREEN:
    'view_add_teen_without_ssn_warning_screen',
  SELECT_CREATE_TEEN_IS_UNDER_13: 'select_create_teen_is_under13',
  SELECT_CREATE_TEEN_OPEN_PRIVACY_POLICY:
    'select_create_teen_open_privacy_policy',
  API_ADD_KID_ERROR: 'api_add_kid_error',
  API_ADD_KID_SUCCESS: 'api_add_kid_success',
  API_SKIP_ADD_KID_SWITCHABLE: 'api_skip_add_kid_switchable',
  API_ADD_KID_MATCH_EXISTING_KID_ERROR: 'api_add_kid_match_existing_kid_error',
  API_ADD_KID_FAMILY_CODE_SUCCESS: 'api_add_kid_family_code_success',
  API_ADD_KID_FAMILY_CODE_ERROR: 'api_add_kid_family_code_error',
  SELECT_ADD_KID_FAMILY_CODE_CONFIRM: 'select_add_kid_family_code_confirm',
  SELECT_ADD_KID_ADD_FAMILY_CODE: 'select_add_kid_add_family_code',
} as const;
